import { EtcRankInfo } from "pages/InquiryBoxList/InquiryBoxList";
import { fetcher } from "utils/ApiUtil";
import { IUser } from "./user";
export type ICategoryType = string;
export type TCompanySort = "name" | "popular" | "recent" | "abc";

interface ICompanyListRequest {
  category?: ICategoryType; // category 필터 : default : ALL -> 전체검색
  sorting?: TCompanySort; // ('name|abc': 가나다순 | 'popular': 인기순 | 'recent': 최신순)
  page?: string; // default : '1'
  hide_yn?: "" | "Y" | "N"; // 노출여부 ('': 전체 | 'Y': 비노출 | 'N': 노출)
  open_yn?: "" | "Y" | "N"; // 제휴여부 ('': 전체 | 'Y': 제휴 | 'N': 비제휴(플래닝))
  location_1: string[];
  location_2: string[];
  filter_list: number[];
}

export interface IWeddingListRequest {
  search_params?: string;
  search_name?: string;
  open_yn?: "ALL" | "Y" | "N";
  hide_yn?: "ALL" | "Y" | "N";
  offset?: number;
  category: "웨딩홀";
  page: number;
  sorting: "popular" | "abc" | "";
  location_1?: string[];
  location_2?: string[];
  filter_list?: number[];
}
export interface ICompanySpot {
  no: number;
  contructor_no: number;
  name: string;
  reservation_type: "in" | "kakao" | "site" | "tel";
  reservation_url: string;
  del_yn?: "Y" | "N";
}

export interface ICompanyReviewPhoto {
  no: number;
  review_no: number;
  img_url: string;
  del_yn: "Y" | "N";
}

export interface ICompanyReview {
  no: number;
  user_no: number;
  contructor_no: number;
  title: string;
  content: string;
  like_cnt: number;
  view_cnt: number;
  rating: number;
  hide_yn?: "Y" | "N";
  del_yn?: "Y" | "N";
  photo?: ICompanyReviewPhoto[];
  user: IUser;
  contract_yn?: "Y" | "N";
  createdAt: string;
  updatedAt: string;
  updatedDt: string;
  createdDt: string;
  blind_yn?: "Y" | "N";
  blindDt?: string;
  blind_content?: string;
  point_yn?: "Y" | "N";
  contract_day?: string;
  visit_day?: string;
  confirm_yn?: "Y" | "N";
}

export type THallPhotos = {
  no: number;
  del_yn: "N" | "Y";
  img_url: string;
  ordering: number;
  createdAt?: string;
  createdDt?: string;
  updatedAt?: string;
  updatedDt?: string;
  wedding_hall_no: number;
};

export interface IHallInfo {
  hall_name?: string | null;
  hall_type?: string | null;
  hall_term?: string | null;
  hall_max?: string | null;
  hall_style?: string | null;
  meal_type?: string | null;
  min_headcount?: string | null;
  hall_headcount?: string | null;
  max_headcount?: string | null;
  checked: boolean;
  no: number;
  photos?: THallPhotos[];
  del_yn?: "Y" | "N";
  createdAt?: string;
  updatedAt?: string;
}

export interface ICompany {
  no: number;
  name: string;
  tag: string;
  coment: string;
  instagramUrl: string;
  homepageUrl: string;
  address: string;
  substation: string;
  category: string;
  type: string;
  min_estimate: string;
  max_estimate: string;
  estimate: string;
  alliance_yn: "N" | "Y";
  createdAt: string;
  updatedAt: string;
  additinal: {
    no: number;
    contructor_no: number;
    type: string;
    context: string;
  }[];
  benefit: string[];
  photo: {
    no: number;
    community_no: number;
    img_url: string;
    createdAt: string;
  }[];
  thumb_photo: {
    no: number;
    community_no: number;
    img_url: string;
    createdAt: string;
  }[];
  product: {
    no: number;
    community_no: number;
    img_url: string;
    createdAt: string;
  }[];
  scrapYN?: { yn: "Y" | "N"; scrap_no?: number };
  open_yn?: "Y" | "N";
  reservation_type?: string;
  reservation_url?: string;
  spotlist: ICompanySpot[];
  jnique_yn: "Y" | "N";
  lewedding_yn: "Y" | "N";
  review?: {
    page: IPage;
    review: ICompanyReview[];
    totalRating: string;
  };
  reviewCnt?: number;
  totalRating?: string;
  openhour?: string;
  restday?: string;
  youtube_url?: string;
  youtube_thumbnail?: string;
  hide_yn?: "Y" | "N";
  wedding_hall?: IHallInfo[];
  hall_list?: IHallInfo[];
}
export interface ICompanyListData {
  result: {
    Contructor: ICompany[];
    page: IPage;
  };
}
export interface ICompanySpot {
  no: number;
  contructor_no: number;
  name: string;
  reservation_type: "in" | "kakao" | "site" | "tel";
  reservation_url: string;
  del_yn?: "Y" | "N";
}

export async function getCompanyList({
  category = "ALL",
  sorting = "popular",
  page = "1",
  hide_yn = "N",
  open_yn = "Y",
  location_1 = [],
  location_2 = [],
  filter_list = [],
}: ICompanyListRequest) {
  return await fetcher<ICompanyListData>("/api/contructor/contructorlist", {
    category,
    sorting,
    page,
    hide_yn,
    open_yn,
    location_1,
    location_2,
    filter_list,
  });
}

export async function getWeddingList({
  search_name = "",
  category = "웨딩홀",
  open_yn = "Y",
  hide_yn = "N",
  page = 1,
  offset = 10,
  sorting = "abc",
  location_1,
  location_2,
  filter_list,
}: IWeddingListRequest) {
  return await fetcher<ICompanyListData>("/api/contructor/searchcontructor", {
    search_name,
    category,
    open_yn,
    hide_yn,
    page,
    offset,
    sorting,
    location_1,
    location_2,
    filter_list,
  });
}
export async function getCompanyDetail(contructor_no: number) {
  return await fetcher<{
    result: ICompany;
  }>("/api/contructor/contructordetail", {
    contructor_no,
  });
}

export interface AllSearchData {
  contructor: ICompany[];
}

export async function allSearch(search_params: string = "") {
  return await fetcher<{ data: AllSearchData }>("/api/user/allsearch", {
    search_params,
  });
}

export async function getCompanyReviewList({
  page,
  contructor_no,
}: {
  page: string;
  contructor_no: string;
}) {
  return await fetcher<{
    result: {
      page: IPage;
      review: ICompanyReview[];
      totalRating: string;
    };
  }>("/api/contructor/contructorReviewList", {
    page,
    contructor_no,
  });
}

export async function getCompanyReviewPhotoList({
  contructor_no,
}: {
  contructor_no: string;
}) {
  return await fetcher<{
    result: ICompanyReviewPhoto[];
  }>("/api/contructor/getCompanyReviewPhotoList", {
    limit: 10,
    contructor_no,
  });
}

export async function getCompanyReviewDetail({
  contructor_no,
  review_no,
}: {
  contructor_no: string;
  review_no: string;
}) {
  return await fetcher<{
    result: ICompanyReview;
  }>("/api/contructor/contructorReviewDetail", {
    contructor_no,
    review_no,
  });
}

export async function cancelInquiryBox({
  estimate_no,
  estimate_sub_no,
  counsel_cancel_reason,
}: {
  estimate_no: number;
  estimate_sub_no: number;
  counsel_cancel_reason?: string;
}) {
  return await fetcher("/api/user/cancelEstimate", {
    estimate_no: estimate_no,
    estimate_sub_no: estimate_sub_no,
    counsel_cancel_reason: counsel_cancel_reason || "",
  });
}

export async function changeInquiryBox({
  estimate_no,
  estimate_sub_no,
  counselChangeReason,
  change_requests,
}: {
  estimate_no: number;
  estimate_sub_no: number;
  counselChangeReason?: string;
  change_requests: EtcRankInfo[];
}) {
  return await fetcher("/api/user/changeEstimateV2", {
    estimate_no,
    estimate_sub_no,
    cancel_yn: "N",
    change_requests,
    counsel_change_reason: counselChangeReason || "",
  });
}
